import $ from 'jquery';

// ### Responsive tables
// Get all table elements inside the content container
// & create wrapper container around them
$('.main table')
  .not('.responsive-enabled')
  .not('.js-noscroll')
  .not('.flights__table')
  .addClass('table-init')
  .wrap('<div class="table-scroll"/>');

let timeout = null;
const observer = new MutationObserver((mutations) => {
  clearTimeout(timeout);
  setTimeout(() => {
    $('.main table:not(.table-init)')
      .not('.responsive-enabled')
      .not('.js-noscroll')
      .not('.flights__table')
      .addClass('table-init')
      .wrap('<div class="table-scroll"/>');
  }, 100);
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});
